import axios from "axios";

const mainAxios = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  
});
const printAxios = axios.create({
  headers: {"Access-Control-Allow-Origin": "*"}
});
const pcareAxios = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_PCARE,
    headers: {"Access-Control-Allow-Origin": "*"}
});

export { mainAxios,printAxios, pcareAxios };